var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooljs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "45.655px",
    viewBox: "0 0 40 45.655",
    enableBackground: "new 0 0 40 45.655",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E9CA32",
    d: "M3.349,40.934L0,0h40l-3.541,40.934l-16.308,4.723L3.349,40.934z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDE25",
    d: "M20.151,41.701V3.898l16.472,0.055l-2.938,33.822L20.151,41.701z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.387,8.387h-4.355v25.162l-3.387-0.646v-3.387l-4.032-0.645v7.58l11.774,3.064V8.387z M21.654,8.387 h12.055l-0.806,4.822h-6.647v7.914h6.647l-0.807,15.972l-10.442,2.42v-5l7.055-2.42l0.408-6.611l-7.463,1.08V8.387z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooljs);
export default __webpack_public_path__ + "static/media/tooljs.73612d9eb479b91536ccb4fb07b97f8f.svg";
export { ForwardRef as ReactComponent };